export default __webpack_public_path__ + "static/media/wegovy-pencap-replace.09df5490.mp4";